export default __webpack_public_path__ + "static/media/teaser_01.6ff428c5.png";